/**
 * Contact Section - Landing Page
 */

import React, { useState } from 'react';
import { Input, Button, Card } from '../../../../design-system';
import { Send } from 'lucide-react';
import { toast } from 'react-toastify';

const Contact = ({ language }) => {
  const isArabic = language === 'ar';
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // API call would go here
      toast.success(isArabic ? 'تم الإرسال بنجاح' : 'Message sent successfully');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      toast.error(isArabic ? 'حدث خطأ' : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="w-full py-16 sm:py-24 md:py-32 lg:py-48 px-3 sm:px-4 bg-[#0B0E14] relative">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#128C7E]/5 via-transparent to-transparent pointer-events-none" />
      
      <div className="relative max-w-2xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-4 sm:mb-6">
            {isArabic ? 'تواصل معنا' : 'Get In Touch'}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#A0AEC0] leading-relaxed">
            {isArabic ? 'لديك سؤال؟ نحن هنا للمساعدة' : 'Have a question? We are here to help'}
          </p>
        </div>

        <Card glass className="p-6 sm:p-8 md:p-12">
          <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
            <Input
              label={isArabic ? 'الاسم' : 'Name'}
              name="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              placeholder={isArabic ? 'أدخل اسمك' : 'Enter your name'}
              required
            />

            <Input
              label={isArabic ? 'البريد الإلكتروني' : 'Email'}
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={isArabic ? 'أدخل بريدك الإلكتروني' : 'Enter your email'}
              required
            />

            <div>
              <label className="block text-xs sm:text-sm font-medium text-[#A0AEC0] mb-2 sm:mb-3">
                {isArabic ? 'الرسالة' : 'Message'}
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
                placeholder={isArabic ? 'أخبرنا بتفاصيل رسالتك' : 'Tell us more about your inquiry'}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-[#0F1218] border border-[#2D3748] rounded-lg text-white text-sm placeholder-[#4A5568] focus:outline-none focus:border-[#128C7E] focus:ring-1 focus:ring-[#128C7E] transition-all"
              />
            </div>

            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-full flex items-center justify-center gap-2 text-sm sm:text-base"
              disabled={loading}
            >
              <Send className="w-4 h-4 sm:w-5 sm:h-5" />
              {isArabic ? 'إرسال الرسالة' : 'Send Message'}
            </Button>
          </form>
        </Card>
      </div>
    </section>
  );
};

export default Contact;
